module.exports = __webpack_public_path__ + "static/media/playlist.d1ef20cd.svg";